import React, { FC } from "react";
import { ActionsGroup, DialogActions, FlatButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { DeleteResourceButton } from "../styled";

interface ActionsProps {
  deleteResources: VoidFunction;
  cancel: VoidFunction;
  loading?: boolean;
}

export const Actions: FC<ActionsProps> = ({ deleteResources, cancel, loading }) => {
  const { t } = useTranslation("common");

  return (
    <DialogActions>
      <ActionsGroup>
        <DeleteResourceButton onClick={deleteResources} primary disabled={loading} isWaiting={loading}>
          {t("actions.delete")}
        </DeleteResourceButton>
        <FlatButton onClick={cancel}>{t("actions.cancel")}</FlatButton>
      </ActionsGroup>
    </DialogActions>
  );
};
